var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('h1',{staticClass:"error-title"},[_vm._v("错误提示：404")]),_c('div',{staticClass:"error-message"},[_vm._v("对不起，您访问的页面不存在")])])
}]

export { render, staticRenderFns }